export const en = {
  dashboard: {
    overview: 'Overview',
  },
  common: {
    languageChanged: 'Language changed',
  },
  translations: {
    server:
      'This message is dynamically generated on the Next.js server and rendered by a React Server Component for a fast and seamless user experience.',
    client:
      'This message is rendered by a React Client Component, showcasing interactive elements and dynamic updates without full page reloads.',
  },
  navigation: {
    dashboard: 'Dashboard',
  },
} as const;
